(function(){
'use strict';
var K='https://a.klaviyo.com/client/subscriptions/?company_id=RsK29n',LIST='WkubBV';
function get(k){try{return localStorage.getItem(k)}catch(e){return null}}
function set(k,v){try{localStorage.setItem(k,v)}catch(e){}}
var params=new URLSearchParams(location.search),FT={};
try{
 FT=JSON.parse(get('dsUtmV2'))||{};
 if(!FT.utm_source&&params.get('utm_source')){
  ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'].forEach(function(k){FT[k]=(params.get(k)||'').slice(0,180)});
  set('dsUtmV2',JSON.stringify(FT));
 }
}catch(e){}
function event(name,extra){
 window.dataLayer=window.dataLayer||[];
 window.dataLayer.push(Object.assign({event:name,brand:'downshift',page_type:'waitlist'},extra||{}));
}
function subscribe(email,source,extra){
 var properties=Object.assign({},FT,{
  signup_source:source,signup_version:'site_v6_oct27',page:location.pathname,
  late_list:true,launch_credit_amount:10,consent_copy_version:'launch_email_oct24'
 },extra||{});
 return fetch(K,{method:'POST',headers:{'content-type':'application/json',revision:'2025-01-15'},
  body:JSON.stringify({data:{type:'subscription',attributes:{profile:{data:{type:'profile',attributes:{
   email:email,properties:properties,subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}}
  }}}},relationships:{list:{data:{type:'list',id:LIST}}}}})
 }).then(function(r){if(!r.ok)throw new Error('Signup was not accepted');});
}
var EM=/^[^\s@]+@[^\s@]+\.[^\s@]+$/;
var success="You're on the list. Your $10 launch credit is saved for your first 30-stick box. Check your inbox for your welcome email.";
function wireForm(f,onSuccess){
 var message=f.querySelector('.d6-msg'),button=f.querySelector('button[type=submit]');
 f.addEventListener('submit',function(e){
  e.preventDefault();
  var email=f.querySelector('input[type=email]').value.trim();
  if(!EM.test(email)){message.textContent="That email doesn't look right.";return;}
  if(!f.querySelector('input[type=checkbox]').checked){message.textContent='Check the box to receive launch emails.';return;}
  var source=f.dataset.src||'popup';
  button.disabled=true;message.textContent='Joining…';
  var pk=f.querySelector('input[name=pack_interest]'),extra=pk?{pack_interest:pk.value}:{};
  subscribe(email,source,extra).then(function(){
   set('dsLate','1');event('waitlist_submit_accepted',{signup_source:source});try{if(window.fbq)fbq('track','Lead',{content_name:'waitlist',value:0,currency:'USD'})}catch(e){}
   onSuccess(email);
  }).catch(function(){message.textContent='Something went wrong. Please try again.';button.disabled=false;event('waitlist_submit_failed',{signup_source:source});});
 });
}
document.querySelectorAll('.d6-form').forEach(function(f){
 wireForm(f,function(){f.innerHTML='<p class="d6-msg" role="status" style="font-size:16px">'+success+'</p>';});
});
event('waitlist_view');
var popup=document.getElementById('d6p');
if(!popup)return;
var forced=params.get('pop')==='1',dismissed=parseInt(get('dsPopNo9')||'0',10),shown=false,email='',returnFocus=null;
function step(n){
 popup.querySelectorAll('.d6p-s').forEach(function(s){s.hidden=s.dataset.s!==String(n);});
 var heading=popup.querySelector('.d6p-s:not([hidden]) h2');
 heading.setAttribute('tabindex','-1');heading.focus({preventScroll:true});
}
function close(){
 popup.hidden=true;document.body.style.overflow='';
 if(!get('dsLate'))set('dsPopNo9',String(Date.now()));
 if(returnFocus&&returnFocus.focus)returnFocus.focus({preventScroll:true});
}
function open(){
 if(shown||(!forced&&get('dsLate')))return;
 var a=document.activeElement;
 if(!forced&&a&&/INPUT|TEXTAREA/.test(a.tagName))return;
 shown=true;returnFocus=a;popup.hidden=false;document.body.style.overflow='hidden';
 event('waitlist_popup_view');popup.querySelector('input[type=email]').focus({preventScroll:true});
}
popup.querySelector('.d6p-x').onclick=close;
popup.querySelectorAll('.d6p-close').forEach(function(b){b.onclick=close;});
popup.addEventListener('click',function(e){if(e.target===popup)close();});
popup.addEventListener('keydown',function(e){
 if(e.key==='Escape'){close();return;}
 if(e.key!=='Tab')return;
 var nodes=Array.from(popup.querySelectorAll('button,input,a[href]')).filter(function(x){return !x.disabled&&x.getClientRects().length;});
 var first=nodes[0],last=nodes[nodes.length-1];
 if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
 else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
});
wireForm(popup.querySelector('.d6p-f'),function(value){email=value;step(2);});
popup.querySelectorAll('.d6p-opts button').forEach(function(button){
 button.onclick=function(){
  var buttons=popup.querySelectorAll('.d6p-opts button'),msg=popup.querySelector('[data-s="2"] .d6-msg');
  buttons.forEach(function(b){b.disabled=true;});msg.textContent='Saving…';
  subscribe(email,'popup',{nightcap_priority:button.dataset.a,preference_optional:true})
   .then(function(){event('waitlist_preference_saved',{preference:button.dataset.a});step(3);})
   .catch(function(){msg.textContent="Your signup is saved, but the preference didn't save. Try again or skip.";buttons.forEach(function(b){b.disabled=false;});});
 };
});
if(forced){setTimeout(open,300);return;}
if(get('dsLate')||get('dsPopDone')||(dismissed&&Date.now()-dismissed<1209600000))return;
var start=Date.now(),armed=function(){return Date.now()-start>8000;};
if(!matchMedia('(pointer:coarse)').matches){
 document.addEventListener('mouseout',function(e){if(!e.relatedTarget&&e.clientY<=0&&armed())open();});
}
window.addEventListener('scroll',function(){var h=document.documentElement;if(armed()&&(h.scrollTop+innerHeight)/h.scrollHeight>0.5)open();},{passive:true});
setTimeout(function(){if(document.visibilityState==='visible')open();},30000);
})();
